import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useInscriptions from "./hooks/useInscriptions";

import AdherentDetails from "./components/AdherentDetails";
import AdherentDrawer from "./components/AdherentDrawer";
import AdherentForm from "./components/AdherentForm";
import AdherentsTable from "./components/AdherentsTable";
import InscriptionsHero from "./components/InscriptionsHero";
import InscriptionsStats from "./components/InscriptionsStats";
import InscriptionsToolbar from "./components/InscriptionsToolbar";
import useScrollToTop from "../../../../hooks/useScrollToTop";

export default function Inscriptions() {
  useScrollToTop();
  const {
    loading,
    saving,
    exporting,
    filters,
    setFilter,
    groups,
    adherents,
    filteredAdherents,
    groupColorMap,
    selectedAdherent,
    drawerMode,
    deleteCandidateId,
    stats,
    actions,
  } = useInscriptions();

  return (
    <div className="space-y-6">
      <InscriptionsHero
        loading={loading}
        totalAdherents={adherents.length}
        filteredCount={filteredAdherents.length}
        selectedGroup={filters.group}
        onCreate={actions.openCreateDrawer}
        onRefresh={actions.refreshData}
      />

      <InscriptionsStats loading={loading} stats={stats} />

      <InscriptionsToolbar
        loading={loading}
        exporting={exporting}
        filters={filters}
        setFilter={setFilter}
        groups={groups}
        filteredCount={filteredAdherents.length}
        totalCount={adherents.length}
        onCreate={actions.openCreateDrawer}
        onExportExcel={actions.exportExcel}
        onExportPDF={actions.exportPDF}
        onRefresh={actions.refreshData}
      />

      <AdherentsTable
        loading={loading}
        adherents={filteredAdherents}
        groupColorMap={groupColorMap}
        sortOrder={filters.sortOrder}
        onSortByName={actions.toggleSortByName}
        onDetails={actions.openDetailsDrawer}
        onEdit={actions.openEditDrawer}
        onAskDelete={actions.askDelete}
        onConfirmDelete={actions.confirmDelete}
        onCancelDelete={actions.cancelDelete}
        deleteCandidateId={deleteCandidateId}
      />

      <AdherentDrawer
        open={Boolean(drawerMode)}
        mode={drawerMode}
        adherent={selectedAdherent}
        onClose={actions.closeDrawer}
      >
        {drawerMode === "details" && selectedAdherent && (
          <AdherentDetails
            adherent={selectedAdherent}
            groupColorMap={groupColorMap}
            onEdit={() => actions.openEditDrawer(selectedAdherent)}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "create" && (
          <AdherentForm
            mode="create"
            groups={groups}
            saving={saving}
            onSubmit={actions.createAdherent}
            onClose={actions.closeDrawer}
          />
        )}

        {drawerMode === "edit" && selectedAdherent && (
          <AdherentForm
            mode="edit"
            adherent={selectedAdherent}
            groups={groups}
            saving={saving}
            onSubmit={actions.updateAdherent}
            onClose={actions.closeDrawer}
          />
        )}
      </AdherentDrawer>

      <ToastContainer position="bottom-right" theme="colored" />
    </div>
  );
}